/* eslint-disable @typescript-eslint/naming-convention */
import { CapacitorConfig } from '@capacitor/cli';

const config: CapacitorConfig  = {
  appId: 'com.rsginc.rmove',
  appName: 'rMove',
  webDir: 'platforms/web/www',
  bundledWebRuntime: false,
  backgroundColor: '#2d2d2d',
  cordova: {
    preferences: {
      ScrollEnabled: 'false',
      BackupWebStorage: 'none',
      SplashMaintainAspectRatio: 'true',
      FadeSplashScreenDuration: '300',
      SplashShowOnlyFirstTime: 'false',
      SplashScreen: 'screen',
      SplashScreenDelay: '3000',
      AndroidXEnabled: 'true',
      GradlePluginGoogleServicesEnabled: 'true',
      GradlePluginGoogleServicesVersion: '4.3.13',
      'deployment-target': '14.0',
      GradlePluginKotlinEnabled: 'true',
      GradlePluginKotlinCodeStyle: 'official'
    }
  },
  android: {
    path: 'platforms/android'
  },
  ios: {
    path: 'platforms/ios',
    preferredContentMode: "mobile"
  }
};

export default config;
